export const chartHeight = (graphDiv) => {
  return graphDiv?._fullLayout.height
}

// Gives the postion of x value in the chart in terms of pixels
// d2p: is date to pixel  funtion provided by plotly
export const xValuePositionInPixel = (plotlyXaxis, xValue, layout) => {
  return plotlyXaxis?.d2p(xValue) + layout.margin.l
}
